import React, { Component } from 'react'
import {
  NavBar,
  Icon,
  List,
  WhiteSpace,
  WingBlank,
  Toast,
  SearchBar,
  Card
} from 'antd-mobile'
import axios from '../../../service/axios'
import './index.scss'
const Item = List.Item
const userMsg = 
  sessionStorage.getItem("loginMsg") &&
  JSON.parse(sessionStorage.getItem("loginMsg"));
export default class DMRDevice extends Component {
  state = {
      cardInfo: {},
      cardStatus:{},
      monthFlow:{},
      deviceList: []
  }
  componentWillMount() {
    this.getDeviceList()
  }

  // 获取设备列表
  getDeviceList() {
    Toast.loading("加载中...", 0);
    axios
      .post(
        '/api/dmrgw/wechat/list',
        {loginName:userMsg.loginName}
      ).then(res => {
        console.log(res,"??")
        console.log(userMsg.loginName)
        if( res && res.status == 200){
          this.setState(
            this.state.deviceList = res.data.resultList
          )
          
        }
      })
    }
  render() {
    const {deviceList} = this.state
    return (
      <div className="DeviceInfo">
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left"/>}
            onLeftClick={() => this.props.history.goBack()}
          >
            设备列表
          </NavBar>
        </div>
        <div className="sub-container"> 
          <WingBlank>
            <div>
              {/* <Item onClick={()=>
                this.props.history.push('/deviceInfo')
              }>
                1
              </Item> */}
              {deviceList.map((item, index) => (
                <div key={index}>
                  <WhiteSpace size='xl'/>
                  <Card onClick={()=>{
                    console.log("card!",index)
                    this.props.history.push('/deviceInfo?'+item.id)
                  }}>
                    <Card.Body>
                      <div>设备名称:<span>{item.dmrName}</span></div>
                      <div>IMEI:<span>{item.dmrImei}</span></div>
                      <div>状态:<span>{item.status === 0?<span style={{color:"red"}}>未启用</span>:<span style={{color:"green"}}>已启用</span>}</span></div>
                    </Card.Body>
                  </Card>
                </div>
              ))} 
              
            </div>
          </WingBlank>
        </div>
      </div >
    )
  }
}